module.exports = __webpack_public_path__ + "static/img/roboto-v32-cyrillic_cyrillic-ext_latin_latin-ext-regular.8681f43.svg";